import { request } from '@/shared/api/request'

export const getSections = (sections, captcha) => {
	return request({
		url: `/selftest/get/sections?ignoreCaptcha=false&captcha=${captcha}`,
		method: 'POST',
		data: sections,
	})
}
